import React from 'react'
import { jt, t } from 'ttag'

import { CopyTemplateModal } from 'components/modals/common/CopyTemplateModal/CopyTemplateModal'

import { useCopyTemplateModal } from 'components/modals/common/CopyTemplateModal/hooks'

export const CopyJobTemplateModal = ({
  template,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const { state, handlers } = useCopyTemplateModal({
    onCancel,
    onClose,
    onConfirm,
  })

  const { copy } = state
  const { handleCancel, handleClose, handleConfirm } = handlers

  const title = template?.name

  const message = (
    <strong key="template">{t`based on ${title} template`}</strong>
  )

  return (
    <CopyTemplateModal
      alert={jt`You are creating a new job template ${message}.`}
      form={copy}
      label={t`Job template name`}
      title={t`Copy job template`}
      onCancel={handleCancel}
      onClose={handleClose}
      onConfirm={handleConfirm}
      {...{ isOpen }}
    />
  )
}
